import { Tag } from 'antd';

export const decisionTypeTexts = {
  approved: 'Uygundur',
  not_approved: 'Uygun Değildir',
};

function DecisionTypeBadge({ text }) {
  const handleColor = (text) => {
    switch (text) {
      case 'approved':
        return 'green';
      case 'not_approved':
        return 'red';
    }
  };

  return <Tag color={handleColor(text)}>{decisionTypeTexts[text]}</Tag>;
}
export default DecisionTypeBadge;
